import React from 'react';
import DetectiveIDCard from '@/components/DetectiveIDCard';

const sampleCard = {
  displayName: 'ShawnSpencerFan',
  detectiveAlias: 'The Pineapple Whisperer',
  consultantId: 'SBPDA-2026-04471',
  joinDate: '03/15/2026',
  currentRank: 'Pineapple Tracker',
  xpTotal: 2847,
  badges: ['🍍', '🔮', '💬', '🚙'],
};

export default function IDCardShowcase() {
  return (
    <section id="id-card" className="py-24 bg-muted/20 border-y border-border">
      <div className="px-6 max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">Exclusive Feature</p>
            <h2 className="text-hero-md font-extrabold text-foreground mb-5">
              Your Psychic Detective<br />
              <span className="gradient-text-primary">Agency ID Card</span>
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-8">
              Every fan gets a unique, laminated-style Detective Agency credential. Your consultant ID, rank, 
              XP total, badge collection, and detective alias — all in one collectible card that updates as you progress.
            </p>
            <ul className="space-y-3">
              {[
                { icon: '🆔', text: 'Unique Consultant ID generated at signup' },
                { icon: '📸', text: 'Your avatar embedded in the credential' },
                { icon: '🏅', text: 'Badge slots fill as you earn achievements' },
                { icon: '📊', text: 'Live XP and rank always up to date' },
                { icon: '📤', text: 'Shareable card for social media' },
              ]?.map((item, i) => (
                <li key={`id-feature-${i}`} className="flex items-center gap-3 text-sm text-muted-foreground">
                  <span className="text-base">{item?.icon}</span>
                  <span>{item?.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex justify-center">
            <div className="animate-float">
              <DetectiveIDCard data={sampleCard} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}